import React from 'react';
import './App.css';

function ScoreBoard({ scores, setScores, onBack }) {
  const handleInputChange = (index, field, value) => {
    const newScores = [...scores];
    newScores[index][field] = value;
    setScores(newScores);
  };

  const handleAddGame = () => {
    setScores([...scores, { teamA: '', teamB: '', scoreA: 0, scoreB: 0, game: '' }]);
  };

  return (
    <div className="scoreboard-container">
      <button className="back-btn" onClick={onBack}>بازگشت</button>
      <h2>جدول امتیازها</h2>
      <table className="scoreboard-table">
        <thead>
          <tr>
            <th>بازی</th>
            <th>تیم/بازیکن A</th>
            <th>امتیاز A</th>
            <th>تیم/بازیکن B</th>
            <th>امتیاز B</th>
          </tr>
        </thead>
        <tbody>
          {scores.map((row, idx) => (
            <tr key={idx}>
              <td>
                <input type="text" value={row.game} onChange={e => handleInputChange(idx, 'game', e.target.value)} placeholder="نام بازی" />
              </td>
              <td>
                <input type="text" value={row.teamA} onChange={e => handleInputChange(idx, 'teamA', e.target.value)} placeholder="تیم/بازیکن A" />
              </td>
              <td>
                <input type="number" value={row.scoreA} onChange={e => handleInputChange(idx, 'scoreA', Number(e.target.value))} min="0" />
              </td>
              <td>
                <input type="text" value={row.teamB} onChange={e => handleInputChange(idx, 'teamB', e.target.value)} placeholder="تیم/بازیکن B" />
              </td>
              <td>
                <input type="number" value={row.scoreB} onChange={e => handleInputChange(idx, 'scoreB', Number(e.target.value))} min="0" />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <button className="add-game-btn" onClick={handleAddGame}>افزودن بازی جدید</button>
    </div>
  );
}

export default ScoreBoard;
